import { CheckoutPaymentMethod, CheckoutAdminPaymentMethod } from '@raskrask-dk/raskrask-utils'
import { Action } from '../../../action/action'
import type CheckoutState from '../checkoutState'

export const CHOOSE_PAYMENT_METHOD = 'CHOOSE_PAYMENT_METHOD'
export class ChoosePaymentMethod extends Action<
    typeof CHOOSE_PAYMENT_METHOD,
    CheckoutPaymentMethod | CheckoutAdminPaymentMethod
> {
    readonly type = CHOOSE_PAYMENT_METHOD
    protected state: CheckoutState

    constructor(
        state: CheckoutState,
        paymentMethod?: CheckoutPaymentMethod | CheckoutAdminPaymentMethod
    ) {
        super(state, paymentMethod)
        this.state = state
    }
    /**
     * Business Logic:
     * This Action is only available if the customer has to pay something.
     * @returns
     */
    public isDoable(): boolean {
        const priceToPay = this.state.priceToPay
        const shouldChoosePaymentType =
            priceToPay === undefined
                ? false
                : priceToPay === 'COVERED' || priceToPay > 0
                ? true
                : true
        return shouldChoosePaymentType
    }
    public isValid(): boolean {
        return this.isDoable()
    }
}
